export enum CurrencyCodeEnum {
    USD = 'USD',
    KRW = 'KRW'
}
